import styled from "@emotion/styled";
import {
  Grid,
  GridColumn,
  H2,
  MediaQueries,
  Section,
  Spacings,
} from "@polestar/component-warehouse-react";

import FeaturedPartnersTile, {
  type FeaturedPartnersTileProps,
} from "./FeaturedPartnersTile";

const StyledH2 = styled(H2)`
  white-space: pre-line;
`;

const StyledGrid = styled(Grid)`
  grid-row-gap: ${Spacings.xxLarge};

  ${MediaQueries.tablet} {
    grid-row-gap: ${Spacings.xxxLarge};
  }
`;

interface FeaturedPartnersProps {
  readonly title?: string;
  readonly tiles: Array<FeaturedPartnersTileProps & { _datoRecordId: string }>;
}

const FeaturedPartners = ({ tiles, title }: FeaturedPartnersProps) => {
  return (
    <Section>
      <Grid>
        <GridColumn span={{ mobile: 4, tablet: 8, desktop: 12 }}>
          <StyledH2>{title}</StyledH2>
        </GridColumn>
        <GridColumn span={{ mobile: 4, tablet: 8, desktop: 12 }}>
          <StyledGrid nested>
            {tiles.map((tile) => {
              return (
                <GridColumn
                  key={tile._datoRecordId}
                  span={{ mobile: 4, desktop: 4, tablet: 4 }}
                >
                  <FeaturedPartnersTile
                    body={tile.body}
                    button={tile.button}
                    imageSet={tile.imageSet}
                    title={tile.title}
                  />
                </GridColumn>
              );
            })}
          </StyledGrid>
        </GridColumn>
      </Grid>
    </Section>
  );
};

export default FeaturedPartners;
